import { render, staticRenderFns } from "./StatsSaleModel.vue?vue&type=template&id=73ed06d4&"
import script from "./StatsSaleModel.vue?vue&type=script&lang=js&"
export * from "./StatsSaleModel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports